<template>
  <transition
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
  >
    <div v-if="show" class="modal-wrapper">
      <div class="modal-content-wrap">
        <img
          class="btn-close"
          src="https://res.pandateacher.com/Q7MBF9291630655461672.png"
          alt=""
          @click="onCancel"
        />
        <img class="img-main" :src="strategyData.gift_bg" alt="" />
        <div
          class="btn-confirm"
          :style="{ backgroundImage: `url(${strategyData.get_gift_btn})` }"
          @click="onConfirm"
        >
          开心收下
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class Repay extends Vue {
  @Prop({ type: Boolean, default: false }) show!: false;
  @Prop({}) strategyData!: any;

  onCancel() {
    this.$emit('cancel');
  }
  onConfirm() {
    this.$emit('confirm');
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/animation.scss';

.animated {
  animation-duration: 0.4s;
}
.fadeIn {
  animation-name: fadeIn;
}
.fadeOut {
  animation-name: fadeIn;
  animation-direction: reverse;
}
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.7);
}
.modal-content-wrap {
  position: relative;

  .btn-close {
    position: absolute;
    top: 48px;
    left: 118px;
    width: 66px;
    height: 66px;
  }
  .img-main {
    width: 750px;
    height: 715px;
    margin-bottom: 36px;
  }
  .btn-confirm {
    width: 410px;
    height: 110px;
    margin: 0 auto;
    color: #ffffff;
    font-weight: bold;

    font-size: 52px;
    line-height: 100px;
    text-align: center;
    text-shadow: 0px 3px 0px #ba0e1a;
    // background-image: url(https://res.pandateacher.com/QVEC8S8G1630655461710.png);
    background-size: cover;
    animation: heartbeat 0.8s linear infinite;
  }
}
</style>